module.exports = __webpack_public_path__ + "img/Keli.023b743a.jpeg";